import apiClient from '../index';

export const settingsApi = {
  // Get event settings - GET /api/event/get-settings
  getEventSettings: async () => {
    try {
      const response = await apiClient.get('/event/get-settings');
      return response;
    } catch (error) {
      console.error('Error fetching event settings:', error);
      if (error.response?.status === 404) {
        return { data: {} };
      }
      if (error.response?.status === 401) {
        console.warn('Unauthorized to fetch event settings - using defaults');
        return { data: {} };
      }
      throw error;
    }
  },
  
  // Update event settings - PUT /api/event/update-settings/{id}
  updateEventSettings: (id, data) => apiClient.put(`/event/update-settings/${id}`, data),

  // Get custom templates (notification settings) - GET /api/event/get-custom-message-templates
  getCustomTemplates: () => apiClient.get('/event/get-custom-message-templates'),

  // Update custom templates - PUT /api/event/update-custom-message-templates
  updateCustomTemplates: (data) => apiClient.put('/event/update-custom-message-templates', data),

  // Color Settings (stored in localStorage only)
  getColorSettings: () => {
    const saved = localStorage.getItem('theme_colors');
    return saved ? JSON.parse(saved) : null;
  },
  saveColorSettings: (data) => {
    localStorage.setItem('theme_colors', JSON.stringify(data));
    return Promise.resolve({ success: true });
  }
};

export default settingsApi;